import { IAppState } from '@myStore/app.state';
import { IWorkDebtorsState } from '@myStore/work-debtors/work-debtors.state';
import { createSelector } from '@ngrx/store';

const workDebtorsSelector = (state: IAppState) => state.workDebtors;

export const selectWorkDebtorsNotes = createSelector(
  workDebtorsSelector,
  (state: IWorkDebtorsState) => state?.workDebtorsNotes.data
);

export const selectWorkDebtorsNotesLoading = createSelector(
  workDebtorsSelector,
  (state: IWorkDebtorsState) => state?.workDebtorsNotes.isLoading
);

export const selectWorkDebtorsByGroup = createSelector(
  workDebtorsSelector,
  (state: IWorkDebtorsState) => state?.data
);

export const selectWorkDebtorsByGroupLoading = createSelector(
  workDebtorsSelector,
  (state: IWorkDebtorsState) => state?.isLoading
);

export const selectAddWorkDebtorsSuccess = createSelector(
  workDebtorsSelector,
  (state: IWorkDebtorsState) => state?.success
);

export const selectAddWorkDebtorsFailure = createSelector(
  workDebtorsSelector,
  (state: IWorkDebtorsState) => state?.errors
);

export const selectWorkDebtorsLoadingChanges = createSelector(
  workDebtorsSelector,
  (state: IWorkDebtorsState) => state?.isLoadingChanges
);
